'use client'

import { X24 } from '@vinted/monochrome-icons'
import {
  Button,
  Cell,
  Divider,
  Dialog,
  Navigation,
  Spacer,
  Text,
  BottomSheet,
} from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

import { SERVICE_FEE_HELP_URL, SERVICE_FEE_PRO_HELP_URL } from '../../constants/routes'

type Props = {
  isSellerBusinessUser?: boolean
  isOpen: boolean
  isOpenedInDialog?: boolean
  onClose: () => void
}

const BundleRefundsBuyerProtectionFeeModal = ({
  isOpen,
  onClose,
  isSellerBusinessUser = false,
  isOpenedInDialog = false,
}: Props) => {
  const translate = useTranslate('bundle_refunds_buyer_protection_fee')
  const serviceFeeHelpUrl = isSellerBusinessUser ? SERVICE_FEE_PRO_HELP_URL : SERVICE_FEE_HELP_URL
  const translationKeyPrefix = isSellerBusinessUser ? 'pro_' : ''

  const { phones } = useBreakpoint()
  const isMobileView = phones && !isOpenedInDialog

  const renderContent = () => {
    return (
      <>
        <Navigation
          body={translate(`${translationKeyPrefix}title`)}
          right={
            <Button
              inline
              iconName={X24}
              styling={Button.Styling.Flat}
              testId="bundle-refunds-buyer-protection-fee-close"
              onClick={onClose}
              aria={{ 'aria-label': translate('a11y.close') }}
            />
          }
        />
        <Divider />
        <Cell>
          <Text as="span" text={translate(`${translationKeyPrefix}body`)} />
          <Spacer size={Spacer.Size.Large} />
          <a href={serviceFeeHelpUrl} target="_blank" rel="noreferrer">
            {translate('learn_more')}
          </a>
          {!isMobileView && (
            <>
              <Spacer size={Spacer.Size.XLarge} />
              <Button
                text={translate('action')}
                styling={Button.Styling.Filled}
                onClick={onClose}
              />
            </>
          )}
        </Cell>
      </>
    )
  }

  if (isMobileView) {
    return (
      <BottomSheet isVisible={isOpen} onClose={onClose}>
        {renderContent()}
      </BottomSheet>
    )
  }

  return (
    <Dialog show={isOpen} defaultCallback={onClose} closeOnOverlay>
      {renderContent()}
    </Dialog>
  )
}

export default BundleRefundsBuyerProtectionFeeModal
